
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const h251: IProductData = {
  id: "heiserman-h251",
  name: "Heiserman Audio H251",
  description: "Large Diaphragm Tube Condenser Microphone",
  specialOrder: true,
  images: ["/img/heisermanaudio_type251.png", "/img/heisermanaudio_type251_internal.png"],
  details: [{
    label: "Description",
    markdown: `
Highly detailed recreation of the 251 large diaphragm tube condenser microphone with 6072 TAD Highgrade tube, Generation 4 Hk12 brass and acrylic chambered capsule, and omni, cardioid and figure-8 polar patterns.  
Heiserman H251 is a handcrafted, historically accurate recreation of the legendary AKG C12 microphone.  
This microphone was engineered with incredible care and attention to detail, making it a top choice for audio professionals looking for the ultimate in high-quality audio capture.  

At the heart of the Heiserman H251 is the Generation-4 Heiserman Hk12 capsule, made with brass and acrylic chambered backplates and rich 6µm gold sputtered DuPont Mylar, which provides unmatched clarity and fidelity.  
The capsule is paired with a 6072 vacuum tube and the T14/1 transformer, which is an exact replica of a pristine vintage unit from 1961.  
The acrylic circuit board and full acrylic head assembly, complete with the original rotational pattern switch and full Ck12 saddle with felts and foam cushioning, make the H251 a true-to-original recreation.  

Equipped with Vishay and Takman Rex resistors, NOS polystyrene and PIO capacitors, and a true-to-original design wet Tantalum output capacitor, the Heiserman H251 reproduces audio with extreme accuracy.  
The microphone features switchable polar patterns, including cardioid, omni, and figure-8, providing the user with greater versatility for different recording situations.  

With a maximum SPL of 130 dB and a frequency range of 20 Hz - 20 kHz, the Heiserman H251 can handle even the most demanding recording situations.  
The H251 comes with a custom bulletproof power supply with world switching, a 7.5-meter Sommer tube mic cable with custom 251 style connector, and a rugged flight case, making it a perfect choice for on-the-go recording sessions.  
`
  }, {
    label: "Features",
    markdown: `
- Highly detailed recreation of the 251 large diaphragm tube condenser microphone
- Generation 4 Hk12 capsule with the same brass and acrylic chambered backplates and rich 6µm gold sputtered DuPont Mylar
- T14/1 transformer engineered from a pristine vintage unit from 1961
- Vishay and Takman Rex resistors, NOS polystyrene and PIO capacitors
- Custom bulletproof power supply with world switching, a 7.5 meter Sommer tube mic cable with custom 251 style connector and a rugged flight case included
    `
  }, {
    label: "Specifications",
    markdown: `
- LENGTH | 216mm
- DIAMETER | 50mm
- POLAR PATTERN | Cardioid, Omni, Figure-8
- Capsule | Generation 4 Hk12 Brass and Acrylic Chambered
- Tube | 6072 TAD Highgrade
- Transformer | T14/1
- Sensitivity | 17mV/Pa ± 1dB
- THD @ 1Khz @ 1Pa | <0.3%
- IMPEDANCE | 200 ohms / 50 Ohms (switchable via jumper links)
- FREQUENCY RANGE | 20 Hz - 20 kHz
- MAX. SPL | 130 dB
- Self Noise | 10dBA
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://heisermanaudio.com/products/h251-microphone-reservation-list" target="_blank">https://heisermanaudio.com/products/h251-microphone-reservation-list</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.MICROPHONE],
    manufacturer: BRAND.HEISERMAN,
  }
}